import { render, staticRenderFns } from "./TrancheBorrower.vue?vue&type=template&id=7e06178e&scoped=true&"
import script from "./TrancheBorrower.vue?vue&type=script&lang=js&"
export * from "./TrancheBorrower.vue?vue&type=script&lang=js&"
import style0 from "./TrancheBorrower.vue?vue&type=style&index=0&id=7e06178e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06178e",
  null
  
)

export default component.exports